<template>
    <svg
        viewBox="0 0 32 32"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 23.6006C16.5523 23.6006 17 23.1529 17 22.6006C17 22.0483 16.5523 21.6006 16 21.6006C15.4477 21.6006 15 22.0483 15 22.6006C15 23.1529 15.4477 23.6006 16 23.6006Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.5 27L22.5 27C23.6046 27 24.5 26.1046 24.5 25L24.5 7C24.5 5.89543 23.6046 5 22.5 5H9.5C8.39543 5 7.5 5.89543 7.5 7V25C7.5 26.1046 8.39543 27 9.5 27ZM22.5 20.4707L22.5 25L9.5 25L9.5 20.4707H22.5ZM9.5 11.3486L9.5 18.4707H22.5L22.5 11.3486H9.5ZM22.5 9.34863H9.5L9.5 7L22.5 7V9.34863Z"
        />
    </svg>
</template>
